import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2, LogIn } from 'lucide-react';
import { BRAND } from '../config/brand';

export default function EmailVerificationSuccess() {
  const location = useLocation();
  const email = location.state?.email;
  const accountType = location.state?.accountType;

  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-12 h-12 bg-primary-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">a</span>
            </div>
          </div>

          <div className="flex justify-center mb-3">
            <CheckCircle2 className="w-12 h-12 text-primary-600" />
          </div>

          <h2 className="text-3xl font-bold text-secondary-900">Почта подтверждена</h2>
          <p className="mt-2 text-secondary-600">
            {email ? (
              <>
                Вы успешно подтвердили адрес <b>{email}</b>.
              </>
            ) : (
              'Вы успешно подтвердили email.'
            )}
          </p>
        </div>

        <div className="card p-5">
          <div className="text-sm text-secondary-700">
            Теперь вы можете войти в {BRAND.name}.
          </div>
          {accountType ? (
            <div className="mt-3 text-xs text-secondary-500">
              Тип аккаунта: <b>{accountType === 'guest' ? 'гость' : 'профиль'}</b>
            </div>
          ) : null}

          <div className="mt-5 flex flex-col gap-3">
            <Link
              to="/login"
              state={email ? { email } : undefined}
              className="btn btn-primary w-full flex items-center justify-center"
            >
              <LogIn className="w-4 h-4 mr-2" />
              Войти
            </Link>

            <Link to="/" className="btn btn-secondary w-full">
              На главную
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

